export default {
  all: [],
  currentlySelected: {
    case: {},
    loading: false,
    bookmarked: false,
    viewers: [], // case presence
    taskHistory: [],
    caseFolders: [],
    conversationsPagination: {
      page: 1,
      pageSize: 100,
      total: 0,
      hasMore: false
    }
  },
  loading: false,
  tasks: [],
  taskResult: {},
  taskRunning: true,
  invalidFieldsDialog: {
    show: false,
    invalidFields: [],
    pendingCaseData: null
  }
}
